// ======================================================
// TEF API-Konfiguration
// ======================================================
// Wenn du auf den Server wechselst, sagst du nur:
//   API_MODE = 'server'
//   SERVER_BASE_URL = 'https://dein-server.de/api'
// Der Rest läuft automatisch.
// ======================================================

/**
 * Modus: 'local' = localStorage + JSON-Dateien (Entwicklung)
 *         'server' = REST-API über fetch (Produktion/Server)
 */
export const API_MODE = 'server';

/**
 * Basis-URL des Servers (wird nur bei API_MODE='server' genutzt).
 * Kein Trailing-Slash.
 */
const DEFAULT_ORIGIN =
	(typeof window !== 'undefined' && window.location && window.location.origin) ||
	(typeof globalThis !== 'undefined' && globalThis.location && globalThis.location.origin) ||
	'http://localhost:3100';

export const SERVER_BASE_URL = `${DEFAULT_ORIGIN}/api`;

/**
 * Timeout für Server-Anfragen in Millisekunden.
 */
export const REQUEST_TIMEOUT_MS = 10000;

/**
 * Gibt true zurück wenn gerade im Server-Modus.
 */
export const isServerMode = () => API_MODE === 'server';
